/* eslint-disable no-restricted-properties */
/* eslint-disable consistent-return */
import angular, { isDate } from 'angular';

export default angular.module('filter.mathFilter', [])
  .filter('divide', () => (
    number1: string | number,
    number2: string | number,
  ): number => {
    if (number1 === undefined || number2 === undefined) return -1;

    let num1 = number1;
    let num2 = number2;

    if (typeof num1 === 'string') {
      num1 = String(num1).replace(',', '.');
      num1 = parseFloat(num1);
    }
    if (typeof num2 === 'string') {
      num2 = String(num2).replace(',', '.');
      num2 = parseFloat(num2);
    }

    return num1 / num2;
  })
  .filter('roundUp', () => (value: number): string => {
    const precision = Math.pow(10, 1);
    const roundedValue = Math.ceil(value * precision) / precision;
    return roundedValue.toFixed(1);
  })
  .filter('daysSince', () => (value: Date): number => {
    const date = isDate(value) ? value : new Date(value);
    const dateDiff = new Date().getTime() - date.getTime();
    return Math.ceil(Math.abs(dateDiff) / (1000 * 60 * 60 * 24));
  })
  .filter('booleanCount', () => (value: { [key: string]: boolean | unknown }) => Object
    .values(value).map((o) => o === true)
    .filter((i) => i)
    .length)
  .name;
